import React, { useContext } from 'react';
import { IconName } from 'shared';

import { media } from 'context';
import { Icon, Layout, Link, Text } from 'ds';

import { BROKER_FORM_LINK, BROKER_FORM_LINK_SCROLL_OFFSET } from './constants';

export interface Props {
  icon: IconName;
  title: string;
  description: string;
  ctaText: string;
}

const WhyPartnerCard: React.FC<Props> = ({ icon, title, description, ctaText }) => {
  const { isMobile } = useContext(media);

  return (
    <Layout
      color="white"
      direction="column"
      justify="space-between"
      {...(isMobile
        ? { boxShadow: '2px 0px 22px rgba(87, 73, 109, 0.12)', padding: 36, borderRadius: 8 }
        : { paddingX: 36, paddingY: 44, borderRadius: 24 })}
    >
      <Layout>
        <Layout {...(isMobile ? { align: 'center' } : {})}>
          <Icon name={icon} size="xl" color="blue-600" />
          <Layout {...(isMobile ? { marginLeft: 12 } : { marginTop: 12 })}>
            <Text size="headline-xs" color="blue-600">
              {title}
            </Text>
          </Layout>
        </Layout>
        <Layout marginTop={36}>
          <Text size="body-md" color="gray-400">
            {description}
          </Text>
        </Layout>
      </Layout>
      <Layout marginTop={36}>
        <Link href={BROKER_FORM_LINK} scrollYOffset={BROKER_FORM_LINK_SCROLL_OFFSET}>
          <Layout align="center">
            <Text size="body-md" color="blue-500" semibold>
              {ctaText}
            </Text>
            <Layout display="inline-flex" marginLeft={4}>
              <Icon name="rightChevron" size="xs" color="blue-500" stroke={2} />
            </Layout>
          </Layout>
        </Link>
      </Layout>
    </Layout>
  );
};

export default WhyPartnerCard;
